import React, { useEffect, useState } from 'react';
import '../../../../../scss/pages/Attendance/Component/Attendance/AttendanceHistory/attendanceHistory.scss';
import { useNavigate } from 'react-router';
import LeftArrow from '../../../../../asset/svg/leftArrow.svg';
import { ATTENDANCE_VIEWED_CARD_DATA } from '../../../../../utils/Constants';
import MonthPicker from '../../../../../components/common/MonthPicker';
import { GET_ATTENDANCE_HISTORY_DATA } from '../../../../../sagas/type';
import { getLocalStoreString } from '../../../../../utils/Helper';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Chip, FormControl, Modal, Tab, Tabs, TextField, Typography } from '@mui/material';
import { DataGrid } from "@mui/x-data-grid";
import requestEmptyIcon from '../../../../../asset/svg/requestEmptyIcon.svg';
import { Stack } from '@mui/system';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Checkin from '../../../../../asset/svg/Checkin.svg';
import Checkout from '../../../../../asset/svg/Checkout.svg';
import moment from 'moment'

var today = new Date();
var currentYear = today.getFullYear();
var getMonth = today.getMonth() + 1;
var currentMonth = getMonth < 9 ? '0' + getMonth : getMonth
const currentMonthYear = currentYear + '-' + currentMonth;

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`
    };
}

function attendanceHistory() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { AttendanceHistoryData, } = useSelector(mapStateToProps);
    const [value, setValue] = useState(0);
    const EmployeeCode = getLocalStoreString("EmployeeCode");
    const [selectedMonthYear, setSelectedMonthYear] = useState(currentMonthYear);
    const [calenderValue, setCalenderValue] = useState(currentMonthYear);
    const [history, setHistory] = useState([]);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(100);
    const [totalCount, setTotalCount] = useState(10);
    const [startDate, setStartDate] = useState(today.toISOString().substring(0, 8) + "01");
    const [endDate, setEndDate] = useState(today.toISOString().substring(0, 10))
    const [selectedTabStatus, setSelectedTabStatus] = useState();
    const [selectionModel, setSelectionModel] = useState([]);
    const [selectedRemarkUserDetails, setSelectedRemarkUserDetails] = useState({});
    const [remarkmodal, setRemarkmodal] = useState(false)
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        window.addEventListener("resize", handleResize); handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    document.documentElement.style.setProperty('--screen-width', windowSize.width + 'px');


    const columns = [
        {
            field: "requestedByName",
            headerName: "All Employee",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: 1,
            headerAlign: 'center',
            renderCell: (params) => <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'column', gap: '6px', fontWeight: 600, fontSize: '12px' }}>
                <div >{params?.formattedValue && params?.formattedValue.length > 9 ? params?.formattedValue.substring(0, 9) + "..." : params?.formattedValue}</div>
                <div style={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 400, fontSize: '12px' }}>{params?.row?.requestedBy}</div>
            </div>
        },
        {
            field: "checkInTime",
            headerName: "In",
            type: "number",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: 1,
            headerAlign: 'center',
            renderCell: (params) => <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '6px' }}>
                <div >{params?.formattedValue?.split(',')[0]}</div>
                <div style={{ color: 'rgba(255, 255, 255, 0.40)' }}>{params?.formattedValue?.split(',')[1]}</div>
            </div>
        },
        {
            field: "checkOutTime",
            headerName: "Out",
            type: "number",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: 1,
            headerAlign: 'center',
            renderCell: (params) => <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '6px' }}>
                <div >{params?.formattedValue?.split(',')[0]}</div>
                <div style={{ color: 'rgba(255, 255, 255, 0.40)' }}>{params?.formattedValue?.split(',')[1]}</div>
            </div>
        },
        {
            field: "Remarks",
            headerName: "remarks",
            type: "number",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: 1,
            headerAlign: 'center',
            renderCell: (params) => <div className='attendanceHistory-Container_dataGrid_chip'> <Stack direction="row" spacing={1}><Chip label={params?.row?.status} color={`${params?.row?.status == 'APPROVED' ? 'success' : 'error'}`} variant="outlined" /> </Stack></div>
        },
    ];

    const getAttendanceHistoryData = () => {
        const historyData = {
            startDate: startDate,
            endDate: endDate,
            pageNumber: page,
            pageSize: pageSize,
            status: selectedTabStatus && selectedTabStatus == 'Approved' ? 'APPROVED' : selectedTabStatus == 'Rejected' ? 'REJECTED' : 'NONE',
            approver: EmployeeCode?.length > 0 ? EmployeeCode : null
        };
        dispatch({
            type: GET_ATTENDANCE_HISTORY_DATA,
            payload: historyData,
        });
    }

    useEffect(() => {
        getAttendanceHistoryData();
    }, [startDate, endDate])

    const handleBack = () => {
        navigate(ATTENDANCE_VIEWED_CARD_DATA);
    }

    const handleMonthYear = (monthYear) => {
        setSelectedMonthYear(monthYear);
        setCalenderValue(monthYear);
    }

    const handleChange = (event, newValue) => {
        const { innerText } = event.target
        setSelectedTabStatus(innerText)
        setValue(newValue);
    };

    const formatDate = (dateString) => {
        if (dateString) {
            const date = new Date(dateString);
            const options = { month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
            return date.toLocaleString('en-US', options);
        } else { return '' }
    }

    useEffect(() => {
        if (Object.keys(AttendanceHistoryData).length > 0) {
            const { entities, total } = AttendanceHistoryData;

            const modifiedRequestData = entities && entities?.length > 0 && entities.map((item) => ({
                ...item,
                checkInTime: item?.checkInTime ? moment(item?.checkInTime).format("MMM DD, HH:mm A") : '',
                checkOutTime: item?.checkOutTime ? moment(item?.checkOutTime).format("MMM DD, HH:mm A") : '',
                requestedTime: item?.requestedTime ? moment(item?.requestedTime).format("MMM DD, HH:mm A") : '',
                oldCheckInTime: item?.oldCheckInTime ? moment(item?.oldCheckInTime).format("MMM DD, HH:mm A") : '',
                oldCheckOutTime: item?.oldCheckOutTime ? moment(item?.oldCheckOutTime).format("MMM DD, HH:mm A") : '',
            }))

            if (selectedTabStatus == 'Approved') {
                const approvedData = modifiedRequestData && modifiedRequestData.length > 0 && modifiedRequestData.filter((status) => status.status == 'APPROVED');
                if (approvedData && approvedData.length > 0) { setHistory(approvedData) } else { setHistory([]) }
            } else if (selectedTabStatus == 'Rejected') {
                const approvedData = modifiedRequestData && modifiedRequestData.length > 0 && modifiedRequestData.filter((status) => status.status == 'REJECTED');
                if (approvedData && approvedData.length > 0) { setHistory(approvedData) } else { setHistory([]) }
            } else {
                if (modifiedRequestData && modifiedRequestData.length > 0) { setHistory(modifiedRequestData) } else { setHistory([]) }
            }
            setTotalCount(total);
        }
    }, [selectedTabStatus, AttendanceHistoryData])

    const handleRowClick = (params) => {
        console.log('handleRowClick', params);
        const { row } = params;
        if (Object.keys(row).length > 0) {
            setSelectedRemarkUserDetails(row);
        }
        setRemarkmodal(true);
    };

    const handleCloseModal = () => {
        setRemarkmodal(false);
    }

    const consvertMonthYearDate = () => {
        const date = new Date(selectedMonthYear);
        const month = date.getMonth();
        const year = date.getFullYear();
        const startDate = new Date(year, month, 1);
        const endDate = new Date(year, month + 1, 0);
        const startDateString = startDate.toISOString().split('T')[0];
        const endDateString = endDate.toISOString().split('T')[0];
        setStartDate(startDateString);
        setEndDate(endDateString);
    }

    useEffect(() => {
        consvertMonthYearDate()
    }, [selectedMonthYear])

    return (
        <div className='attendanceHistory-Container'>
            <div className='attendanceHistory-Container_header'>
                <div>
                    <img className='attendanceHistory-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                    <span className='attendanceHistory-Container_header_content'>History</span>
                </div>
            </div>
            <div className='attendanceHistory-Container_calender-Container'>
                <div className='attendanceHistory-Container_calender-Container_childContainer' >
                    <MonthPicker onChange={(monthYear) => handleMonthYear(monthYear)} />
                </div>
            </div>
            <div className='attendanceHistory-Container_tabs-Container'>
                <Tabs value={value} onChange={handleChange}>
                    <Tab label="All" {...a11yProps(0)} style={value == 0 ? { color: 'black', padding: '5px', background: '#FFFFFF', borderRadius: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 500, fontSize: '10px', } : { color: 'white', display: 'flex', alignItems: 'center', justifyContent: "center", padding: '5px', background: 'rgba(255, 255, 255, 0.1)', fontWeight: 500, fontSize: '10px', borderRadius: '40px' }} />
                    <Tab label="Approved" {...a11yProps(1)} style={value == 1 ? { color: 'black', background: '#FFFFFF', borderRadius: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 500, fontSize: '10px', } : { color: 'white', display: 'flex', alignItems: 'center', justifyContent: "center", background: 'rgba(255, 255, 255, 0.1)', fontWeight: 500, fontSize: '10px', borderRadius: '40px' }} />
                    <Tab label="Rejected" {...a11yProps(2)} style={value == 2 ? { color: 'black', padding: '5px', background: '#FFFFFF', borderRadius: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 500, fontSize: '10px', } : { color: 'white', display: 'flex', alignItems: 'center', justifyContent: "center", padding: '5px', background: 'rgba(255, 255, 255, 0.1)', fontWeight: 500, fontSize: '10px', borderRadius: '40px' }} />
                </Tabs>
            </div>
            <div className="attendanceHistory-Container_dataGrid">
                {history && history.length > 0 ? <DataGrid style={{ width: windowSize.width, padding: '0px' }}
                    rows={history}
                    columns={columns}
                    // disableRowSelectionOnClick
                    onRowClick={handleRowClick}
                    // onCellClick={handleCellClick}
                    selectionModel={selectionModel}
                // onColumnHeaderClick={handleOnColumnHeaderClick}
                /> :
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginTop: '10%' }}>
                        <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', width: '159px', height: '159px', borderRadius: '200px', background: 'rgb(222, 225, 255,0.06)', alignItems: 'center' }} >
                            <img style={{ heigth: '54px', width: '68px' }} src={requestEmptyIcon} alt="" />
                        </div>
                        <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                            <Typography fontStyle='normal' fontWeight='400' fontSize='16px' lineHeight='16px' textAlign='center' color='rgba(255,255,255,0.8)' >No entries found</Typography>
                        </div>
                    </div>}
            </div>
            <Modal
                open={remarkmodal}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                <Box sx={{ backgroundColor: ' #0B245F;', borderRadius: '20px', padding: '1rem', display: 'flex', flexDirection: 'column', gap: '10px', width: "85%" }}>
                    <div className='attendanceHistory-Container_closeButton' >
                        <IconButton aria-label="close" sx={{ color: '#FFFFFF' }} onClick={handleCloseModal}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <div className="attendanceHistory-Container_requestedOn-container">
                        <div>
                            <Typography sx={{ color: '#FFF', fontWeight: 700, fontSize: '14px' }}>{selectedRemarkUserDetails?.requestedByName && selectedRemarkUserDetails?.requestedByName.length > 20 ? selectedRemarkUserDetails?.requestedByName.substring(0, 20) + '...' : selectedRemarkUserDetails?.requestedByName}</Typography>
                            <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 500, fontSize: '12px' }}>{selectedRemarkUserDetails?.requestedBy}</Typography>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 500, fontSize: '12px' }}>Requested On</Typography>
                            <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 500, fontSize: '12px' }}>{selectedRemarkUserDetails?.requestedTime}</Typography>
                        </div>
                    </div>
                    <Box sx={{ borderRadius: '12px', background: 'rgba(255,255,255,0.05)', padding: '1rem' }}>
                        <div className="attendanceHistory-Container_checkIn">
                            <img className='attendanceHistory-Container_header_image' src={Checkin} alt="" />&nbsp;&nbsp;
                            <span style={{ color: '#FFF', opacity: '0.30000001192092896', fontWeight: 500, fontSize: '12px', lineHeight: '12px', textTransform: 'capitalize' }}>Check In</span></div>
                        <div className="attendanceHistory-Container_checkIn-content">
                            <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 500, fontSize: '12px' }}>Old : <span className="attendanceHistory-Container_checkIn-content_DateDetails">{selectedRemarkUserDetails?.oldCheckInTime}</span></Typography>
                            <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 500, fontSize: '12px' }}>New : <span className="attendanceHistory-Container_checkIn-content_DateDetails">{selectedRemarkUserDetails?.checkInTime}</span></Typography>
                        </div>
                    </Box>
                    <Box sx={{ borderRadius: '12px', background: 'rgba(255,255,255,0.05)', padding: '1rem' }}>
                        <div className="attendanceHistory-Container_checkIn">
                            <img className='attendanceHistory-Container_header_image' src={Checkout} alt="" />&nbsp;&nbsp;
                            <span style={{ color: '#FFF', opacity: '0.30000001192092896', fontWeight: 500, fontSize: '12px', lineHeight: '12px', textTransform: 'capitalize' }}>Check In</span></div>
                        <div className="attendanceHistory-Container_checkIn-content">
                            <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 500, fontSize: '12px' }}>Old : <span className="attendanceHistory-Container_checkIn-content_DateDetails">{selectedRemarkUserDetails?.oldCheckOutTime}</span></Typography>
                            <Typography sx={{ color: 'rgba(255, 255, 255, 0.40)', fontWeight: 500, fontSize: '12px' }}>New : <span className="attendanceHistory-Container_checkIn-content_DateDetails">{selectedRemarkUserDetails?.checkOutTime}</span></Typography>
                        </div>
                    </Box>
                    <Box sx={{ borderRadius: '12px', background: 'rgba(255,255,255,0.05)', padding: '1rem' }}>
                        <div className="attendanceHistory-Container_checkIn-heading">
                            <Typography sx={{ color: '#FFF', opacity: '0.30000001192092896', fontWeight: 500, fontSize: '12px', lineHeight: '12px', textTransform: 'capitalize' }}>Reason For Update : </Typography>
                            <Typography sx={{ color: '#FFF', fontWeight: 500, fontSize: '12px', lineHeight: '12px', textTransform: 'capitalize', padding: '10px 0px 0px 0px' }}>{selectedRemarkUserDetails?.reason}</Typography>
                        </div>
                    </Box>
                    <Box sx={{ borderRadius: '12px', background: 'rgba(255,255,255,0.05)', padding: '1rem' }}>
                        <div className="attendanceHistory-Container_checkIn-heading">
                            <Typography sx={{ color: '#FFF', opacity: '0.30000001192092896', fontWeight: 500, fontSize: '12px', lineHeight: '12px', textTransform: 'capitalize' }}>Manager Comments : </Typography>
                            <Typography sx={{ color: '#FFF', fontWeight: 500, fontSize: '12px', lineHeight: '12px', textTransform: 'capitalize', padding: '10px 0px 0px 0px' }}>{selectedRemarkUserDetails?.comment}</Typography>
                        </div>
                    </Box>
                    <div className='attendanceHistory-Container_ChipContainer' >
                        <div className='attendanceHistory-Container_ChipContainer_heading' >status : </div>&nbsp;
                        <div className='attendanceHistory-Container_dataGrid_chip'> <Stack direction="row" spacing={1}><Chip label={selectedRemarkUserDetails.status} color={`${selectedRemarkUserDetails.status == 'APPROVED' ? 'success' : 'error'}`} variant="outlined" /> </Stack></div>
                    </div>
                </Box>
            </Modal>
        </div >
    )
};

const mapStateToProps = (state) => {
    return {
        AttendanceHistoryData: state.attendanceConfig.AttendanceHistoryData,
    };
};

export default attendanceHistory;